export default "__VITE_ASSET__DIvj6siq__"